module.exports = "<template> AOK-Prämienprogramm<br> Postfach 100105<br> 44001 Dortmund </template>";